/**
 * First we will load all of this project's JavaScript dependencies which
 * includes other libraries. It is a great starting point when
 * building robust, powerful web applications using Laravel.
 */
var $sectorDetail = $('.sector-detail');
var headerHeight = $('.header-img', $sectorDetail).innerHeight() + $('.header-content-block', $sectorDetail).innerHeight();
var $window = $(window);

$(function () {
    var width = $window.width();
    if (width < 992) {
        $sectorDetail.css({'height': headerHeight});
    }
});

$window.resize(function () {
    var width = $window.width();
    var headerHeightResize = $('.header-img', $sectorDetail).innerHeight() + $('.header-content-block', $sectorDetail).innerHeight() + 24;

    if (width >= 992) {
        $('#navbarSupportedContent').appendTo('.navbar-collapse-desktop');
    } else {
        $('#navbarSupportedContent').appendTo('.navbar-collapse-mobile');
    }
    if (width < 992) {
        if (headerHeight == headerHeightResize) {
            $sectorDetail.height(headerHeight);
        } else {
            $sectorDetail.height(headerHeightResize);
        }
    }
});

$(".mobile-menu").on("click", function () {
    $('.navbar-collapse').toggleClass('collapse');
    $('.mobile-menu').toggleClass('active');
});

$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Accept-Language': $('html').attr('lang'),
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    var width = $(window).width();
    if (width >= 992) {
        $('#navbarSupportedContent').appendTo('.navbar-collapse-desktop');
    } else {
        $('#navbarSupportedContent').appendTo('.navbar-collapse-mobile');
    }

    $('.sector-block').hover(function () {
          var sectorTitleHeight = $(this).find('.sector-title').height();
          var sectorHideHeight = $(this).find('.hide').height() + 10;
          var sectorInfoHeight = sectorTitleHeight + sectorHideHeight;

          $(this).find('.sector-info').height(sectorInfoHeight);
      },
      function () {
          $('.sector-info').removeAttr('style');
      });


    let $contactFormPure = $('#contactFormPure');

    // if the contact form exists in the DOM
    if ($contactFormPure.length > 0) {
        window.showSuccess = function (html) {
            $('#contact-form').html(html);
        }
        $contactFormPure.enableCheckFields().on("sendForm", function() {
            event.preventDefault();

            let $form = $('.sendAjax');
            let formName = $form.prop('name');

            $.ajax({
                type: 'post',
                url: $form.prop('action'),
                dataType: $form.data('type'),
                data: $('form[name='+ formName +']').serialize(),
            }).fail(function (response) {
                $.each(response.responseJSON, function (index, element) {
                    $('#error_' + index).text(element).addClass('d-block')
                });

                // Show error
                $('#gRecapErr').removeClass('d-none');
                $('#gRecapErr').addClass('d-block');

                // We should clear some fields:
                $('#email_confirm_h').val('');
                $('#general-conditions-confirm_h').prop("checked", false);
                $('.btn-submit', $contactFormPure).attr('disabled', false).removeClass('btn-disabled');
            }).done(function (response) {
                window.showSuccess(response.view);
            });
        });
    }
});

// Click on button to go to form
$("#btn-form").click(function () {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#contact-form").offset().top - 100
    }, 2000);
});

//Fix images in content blocks
$(function () {
    function imageAlbum() {
        if ($('img').hasClass('image-album')) {
            $('.container-content').addClass('container-image-album');
        }

        $('.float-left.image-album').closest('p').addClass('float-left');
        $('.float-right.image-album').closest('p').addClass('float-right');

        $.each(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], function (index, value) {
            $(value).each(function () {
                $(this)
                  .parent() // go to parent div (the col-12)
                  .find('.float-left') // find the next float-left from this h4
                  .prev('p') // go back to the upper P
                  .prev(value) // go back to the upper h4
                  .addClass('heading-left') // append class
                ;
            });
        });

        var width = $(document).width();
        if (width <= 992) {
            $('.float-left.image-album').closest('p').removeClass('float-left');
            $('.float-right.image-album').closest('p').removeClass('float-right');
        }
    }

    imageAlbum();

    $(window).resize(function () {
        imageAlbum();
    });
});

$(function () {
    $('#main-content .container-product ul').eq(1).addClass('second');
});